<template>
    <div>
        <b-row 
            :class="[
                {
                    'flex-nowrap': 
                        !$scopedSlots['buscaSimples'] 
                        && 
                        !$scopedSlots['buscaPeriodo'] 
                        && 
                        !$scopedSlots['buscaAvancada']
                }
            ]"
        >
            <!-- Botões -->
            <b-col
                v-if="$scopedSlots['botoes']"
                class="mb-2"
                :class="[
                    botoesClasses,
                    {   
                        'botoes': 
                            $scopedSlots['buscaPeriodo'] 
                            && 
                            $scopedSlots['buscaAvancada'],
                        'text-center': 
                            $scopedSlots['buscaSimples'] 
                            || 
                            (
                                $scopedSlots['buscaPeriodo'] 
                                && 
                                $scopedSlots['buscaAvancada']
                            ),
                        'text-sm-left': 
                            $scopedSlots['buscaSimples'] 
                            || 
                            (
                                $scopedSlots['buscaPeriodo'] 
                                && 
                                $scopedSlots['buscaAvancada']
                            ),
                        'col-auto': 
                            !$scopedSlots['buscaSimples'] 
                            && 
                            !$scopedSlots['buscaPeriodo'] 
                    }
                ]"
            >
                <slot name="botoes"></slot>
            </b-col>
            <!-- Período -->
            <b-col 
                v-if="$scopedSlots['buscaPeriodo']"
                class="mb-2 text-sm-right ml-auto col-12 col-sm-auto busca-periodo "
            >
                <!-- Botão período -->
                <slot name="buscaPeriodo">
                    <periodo
                        :dataMes="$parent.$parent.$data.buscaPeriodo.data_mes"
                        :dataAno="$parent.$parent.$data.buscaPeriodo.data_ano"
                        :dataInicio="$parent.$parent.$data[modelBuscaAvancada][modelDataInicio]"
                        :dataFim="$parent.$parent.$data[modelBuscaAvancada][modelDataFim]"
                        :atualizadoEm="$parent.$parent.$data[modelBuscaAvancada].atualizado_em"
                        :chaveInicio="modelDataInicio"
                        :chaveFim="modelDataFim"
                        :exibeTodoPeriodo="$parent.$parent.$data.buscaPeriodo.exibe_todo_periodo"
                        :exibeProximoMes="$parent.$parent.$data.buscaPeriodo.exibe_proximo_mes"
                    />
                </slot>
                <!-- Botão busca avançada -->
                <b-button
                    v-if="$scopedSlots['buscaAvancada']"
                    id="botao-busca-avancada"
                    :variant="
                        dSituacaoBuscaAvancada 
                        ? 'default' 
                        : 'primary'
                    " 
                    class="ml-1 float-right" 
                    @click.prevent="alternarBuscaAvancada"
                >
                    <i 
                        class="fa" 
                        :class="
                            dSituacaoBuscaAvancada 
                            ? 'fa-search-minus' 
                            : 'fa-search-plus'
                        " 
                    />
                    <span
                        class="ml-1 d-none d-md-inline-block"
                    >
                        Busca avançada
                    </span>
                </b-button>
            </b-col>
            <!-- Busca Simples -->
            <b-col 
                v-if="$scopedSlots['buscaSimples']"
                class="mb-2 col-12 col-sm"
                :class="[
                    {
                        'col-sm-6 col-md-5': 
                            !$scopedSlots['buscaPeriodo'] 
                            && 
                            !$scopedSlots['buscaAvancada']
                    }
                ]"
            >
                <!-- Formulário busca simples -->
                <b-form 
                    data-vv-scope="buscaSimples" 
                    @submit.prevent="enviarBuscaSimples"
                >
                    <b-input-group>
                        <slot name="buscaSimples"></slot>
                        <b-input-group-append>
                        <b-button 
                            v-if="$scopedSlots['buscaSimples']"
                            id="botao-busca-simples"
                            variant="primary"
                            type="submit"
                        >
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button
                            v-if="$scopedSlots['buscaAvancada']"
                            id="botao-busca-avancada"
                            :variant="
                                dSituacaoBuscaAvancada 
                                ? 'default' 
                                : 'primary'
                            "
                            class="ml-1"
                            @click.prevent="alternarBuscaAvancada"
                        >
                            <i 
                                class="fa" 
                                :class="
                                    dSituacaoBuscaAvancada 
                                    ? 'fa-search-minus' 
                                    : 'fa-search-plus'
                                " 
                            />
                            <span
                                class="ml-1 d-none d-md-inline-block"
                            >
                                Busca avançada
                            </span>
                        </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form>
            </b-col>
            <!-- Botão busca avançada -->
            <b-col 
                v-if="
                    !$scopedSlots['buscaSimples'] 
                    && 
                    !$scopedSlots['buscaPeriodo'] 
                    && 
                    $scopedSlots['buscaAvancada']
                "
                class="mb-2 text-right"
            >
                <b-button
                    id="botao-busca-avancada"
                    :variant="
                        dSituacaoBuscaAvancada 
                        ? 'default' 
                        : 'primary'
                    "
                    class="ml-1"
                    @click.prevent="alternarBuscaAvancada"
                >
                    <i 
                        class="fa" 
                        :class="
                            dSituacaoBuscaAvancada 
                            ? 'fa-search-minus' 
                            : 'fa-search-plus'
                        " 
                    />
                    <span
                        class="ml-1 d-none d-md-inline-block"
                    >
                        Busca avançada
                    </span>
                </b-button>
            </b-col>
        </b-row>
        <!-- Formulário busca avançada -->
        <b-card
            v-if="
                $scopedSlots['buscaAvancada'] 
                && 
                dSituacaoBuscaAvancada
            "
            class="mt-2 mb-2"
        >
            <template #header v-if="$scopedSlots['buscaAvancadaHeader']">
                <slot name="buscaAvancadaHeader"></slot>
            </template>
            <b-form 
                data-vv-scope="buscaAvancada" 
                @submit.prevent="enviarBuscaAvancada"
            >
                <b-form-row class="busca-avancada">
                    <slot name="buscaAvancada"
                        :lojas="listaLojas()"
                    ></slot>
                </b-form-row>
                <div>
                    <b-button 
                        type="submit" 
                        variant="success" 
                        class="mr-1"
                    >
                        <i class="glyphicon glyphicon-ok"></i> 
                        Buscar
                    </b-button>
                    <b-button 
                        type="button" 
                        variant="danger"
                        @click="limpaBuscaAvancada()"
                    >
                        <i class="glyphicon glyphicon-remove"></i> Limpar
                    </b-button>
                </div>
            </b-form>
        </b-card>
    </div>
</template>
<script>
import Periodo from './ListaTopoPeriodo'
export default {
    $_veeValidate: {
        validator: 'new' 
    },
    components: {
        Periodo
    },
    props: {
        modelBuscaSimples: {
            default: 'buscaSimples'
        },
        urlBuscaSimples: {
            default: null 
        },
        modelBuscaAvancada: {
            default: 'buscaAvancada'
        },
        situacaoBuscaAvancada: {
            default: false
        },
        modelDataInicio: {
            default: 'data_inicio'
        },
        modelDataFim: {
            default: 'data_fim'
        },
        dataInicio: {
            default: null
        },
        dataFim: {
            default: null
        },
        limpaBuscaPersonalizada: {
            default: false
        },
        botoesClasses: {
            default: ''
        },
        aBuscaDados: {
            type: Function,
            default: null
        }
    },
    data(){
        return {
            dSituacaoBuscaAvancada: this.situacaoBuscaAvancada,
            dUrlBuscaSimples: null,
        }
    },
    mounted() {
        if(this.$parent.situacaoBuscaAvancada){
            this.dSituacaoBuscaAvancada = this.$parent.situacaoBuscaAvancada
        }
        this.dUrlBuscaSimples = this.urlBuscaSimples || this.$route.path
    },
    methods: {
        listaLojas(){
            const lojas = []
            if ( 
                    this.$usuarioLogado.UsuarioLojas 
                    && 
                    this.$usuarioLogado.UsuarioLojas.length
                ) {
                this.$usuarioLogado.UsuarioLojas.forEach(loja => {
                    lojas.push({
                        value: loja.UsuariosLoja.loja_id,
                        text: loja.Loja.nome,
                    })
                })
            }
            return lojas
        },
        async enviarBuscaSimples(){
            const validado = await this.$validator.validateAll('buscaSimples')
            if(!validado){
                return false
            }
            this.$parent.atualizaUrl(
                this.$parent.$parent.$data[this.modelBuscaSimples], 
                false,
                this.dUrlBuscaSimples
            )
        },

        async validaDataInicioFim() {
            // verifica se existe data_inico e data_fim e retorna caso as datas estiverem inválidas
            let buscaAvancadaData = this.$parent.$parent.$data[this.modelBuscaAvancada]
            if (buscaAvancadaData.data_inicio != '' && buscaAvancadaData[this.modelDataFim] != '') {
                let dataInicio = new Date(this.$moment(buscaAvancadaData[this.modelDataInicio],'DD/MM/YYYY').format('YYYY-MM-DD'))
                let dataFim = new Date(this.$moment(buscaAvancadaData[this.modelDataFim],'DD/MM/YYYY').format('YYYY-MM-DD'))

                if (dataInicio > dataFim) {
                    return false
                }
            }
            return true
        },
        async enviarBuscaAvancada(){
            //let validado = true

            if (this.aBuscaDados) {
                if (!(await this.aBuscaDados())) {
                    return
                }
            }

            const validado = await this.$validator.validateAll('buscaAvancada')
            // const dataInicioFimValidate = await this.validaDataInicioFim()
            // if (!dataInicioFimValidate || !validate){
            //     validado = false
            // }
            
            if(validado){
                this.$parent.$parent.$data[this.modelBuscaAvancada]['situacaoBuscaAvancada'] = true
                this.$parent.atualizaUrl(this.$parent.$parent.$data[this.modelBuscaAvancada], false)
            }
        },
        alternarBuscaAvancada(){
            this.dSituacaoBuscaAvancada = !this.dSituacaoBuscaAvancada
        },
        limpaBuscaAvancada(){
            if(this.limpaBuscaPersonalizada){
                this.$emit('limpaBusca')
            } else{
                this.$parent.atualizaUrl({situacaoBuscaAvancada: true}, false)
            }
            
        }
    },
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 512px) { 
    .botoes,
    .busca-periodo{
        display: flex !important;
        justify-content: space-between !important;
    }
    .botoes .dropdown,
    .busca-periodo .dropdown{
        flex-grow: 1;
    }
    #busca-simples{
        font-size: 1em;
        height: 38px;
    }
}
</style>